import spaceStyle from '@/styles/space'
import { Block } from '@/components/base/Block'
import { Heading3 } from '@/components/base/Heading'
import { Icon, LocalIconType } from '@/components/base/Icon'
import { Text4 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { Col, Row } from '../base/Layout'
import CommonPopup from '../base/PopUp/CommonPopup'
import { useState } from 'react'
import { format } from 'date-fns'
import { take } from 'lodash'
import { type V1ResumeFile } from 'mnvm-mypage-app-ts-if'
import { fontSize } from '@/styles/font'

const JobSeekerResumeFiles = ({
  files,
  onDownload
}: {
  files: V1ResumeFile[]
  onDownload: (url: string) => void
}): JSX.Element => {
  const app = useApp()
  const { lightGrayColor } = app.theme
  const [downloadUrl, setDownloadUrl] = useState<string | undefined>(undefined)
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <Block borderBottom padding={{ bottom: '28px' }}>
      <Block maxWidth="570px" margin={{ horizontal: 'auto' }}>
        <Heading3 fixedSPfontSize margin={{ vertical: spaceStyle.M }}>
          登録済みファイル一覧
        </Heading3>

        <Block
          backgroundColor={lightGrayColor}
          padding={{ horizontal: '12px', vertical: '4px' }}
        >
          <Row>
            <Col span={18} xs={16} justify="center" align="flex-start">
              <Text4 margin={{ all: '0' }} fontWeight="700">
                ファイル名
              </Text4>
            </Col>
            <Col span={6} xs={8} justify="center" align="flex-start">
              <Row
                style={{ width: '100%' }}
                justify="space-between"
                align="center"
              >
                <Text4 margin={{ all: '0' }} fontWeight="700">
                  登録日
                </Text4>
                {files?.length >= 4 && (
                  <Icon
                    iconType={
                      isExpanded ? LocalIconType.Remove : LocalIconType.Add
                    }
                    iconStyle={{
                      fontSize: fontSize.M,
                      theme: app.theme.mainTextColor,
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setIsExpanded(!isExpanded)
                    }}
                  />
                )}
              </Row>
            </Col>
          </Row>
        </Block>

        {(isExpanded ? files : take(files, 3)).map((e, idx) => {
          return (
            <Block
              key={`${idx}`}
              padding={{ horizontal: '12px', vertical: '4px' }}
            >
              <Row>
                <Col span={18} xs={16} justify="center" align="flex-start">
                  <Block
                    display="flex"
                    padding={{ horizontal: '4px' }}
                    width="100%"
                  >
                    <Text4
                      textColor={app.theme.primaryMainColor}
                      cursor="pointer"
                      truncate
                      margin={{ all: '0' }}
                      underline
                      onClick={() => {
                        setDownloadUrl(e.url)
                      }}
                    >
                      {e.fileName ?? ''}
                    </Text4>
                  </Block>
                </Col>
                <Col span={6} xs={8} justify="center" align="flex-start">
                  <Text4 margin={{ all: '0' }}>
                    {format(e.registrationDate ?? '', 'yyyy/MM/dd HH:mm:ss')}
                  </Text4>
                </Col>
              </Row>
            </Block>
          )
        })}
      </Block>
      {downloadUrl !== undefined && (
        <CommonPopup
          msg="ファイルをダウンロードしますか？"
          display={downloadUrl !== undefined}
          submitTitle="ダウンロード"
          onClose={() => {
            setDownloadUrl(undefined)
          }}
          onSubmit={() => {
            onDownload(downloadUrl)
          }}
        />
      )}
    </Block>
  )
}

export default JobSeekerResumeFiles
